import router from './router'
import useShipmentStore from './store'
import ShipmentMessages from './localization'

export default {
  router,
  useShipmentStore,
  localization: ShipmentMessages,
}
